<span
  class="icon-{{ name }}"
  [style.font-size]="size"
  [style.color]="color"
  [ngStyle]="customStyle"
></span>
